export default {
  THEME_PANEL_COLORS_TAB: 'dd66bbbd-1dd8-434e-9338-395091aa80d6',
  THEME_PANEL_TEXT_TAB: '4a5e47ac-064c-4718-8382-ae35270230d2',
  THEME_PANEL_TEXT_THEME_TAB: '57c6d996-a6d1-44f6-a1f8-112eb366a9ea',
  COLOR_THEME_INFO: '57c78092-703b-42ae-95c4-7cf85cebc5f1',
  SAVE_THEME_MODAL: '1df23b96-45a4-41e0-b356-e1ee05308c9b',
  SAVE_THEME_MODAL_TEXT_THEME: '5a51c9a5-b933-4fae-ad98-7e7430f9e811',
} as const;
